<template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-else>
            <form @submit.prevent="add_item_badges" autocomplete="off">
                <v-layout row wrap>
                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="item_badges.item_badge_name" type="text"
                            :label="$store.getters.lang.data.item_badge_name" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex>


                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="item_badges.item_badge_color" type="text"
                            :label="$store.getters.lang.data.item_badge_color" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex> -->


                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="item_badges.item_badge_svg" type="text"
                            :label="$store.getters.lang.data.item_badge_svg" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex> -->


                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-select class="mx-1" clearable rounded filled :items="items" v-model="item_badges.item_id" outlined
                            item-text="item_name" item-value="item_id" :return-object="false"
                            :label="$store.getters.lang.data.item_name">
                        </v-select>
                    </v-flex>

                    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn rounded color="primary" type="submit" x-large>{{$store.getters.lang.data.add_btn}}
                            Badge</v-btn>
                    </v-flex>
                </v-layout>
            </form>
            <v-layout row wrap mt-5>
                <v-flex xs12>
                    <v-card>
                        <v-card-title primary-title>
                            {{$store.getters.lang.data.item_badges}}
                            <v-spacer></v-spacer>
                            <v-text-field autocomplete="off" v-model="search" append-icon="fas fa-search">
                            </v-text-field>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table :headers="headers" :search="search" :items="rows" class="elevation-0"
                                item-key="item_badge_id">
                                <template v-slot:[`item.item_badge_id`]="{ item }">
                                    <div>
                                        <v-btn icon color="error" :disabled="$store.state.auth.user.admin_role != 'admin'" class="mx-1" @click="select_item_badges(item)"
                                            rounded>
                                            <v-icon>mdi-delete-outline</v-icon>
                                        </v-btn>
                                        <v-btn :to="'/item_badges-list/'+item.item_badge_id" icon color="secondary"
                                            class="mx-1" rounded>
                                            <v-icon>mdi-pencil-outline</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="delete_dialog" persistent max-width="290">
            <v-card>
                <v-card-title>
                    {{$store.getters.lang.data.delete_question}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" class="elevation-0" @click="delete_dialog = false">
                        {{$store.getters.lang.data.cancel_btn}}
                    </v-btn>
                    <v-btn color="green darken-1" text @click="delete_item_badges(selected_item_badges.item_badge_id)">
                        {{$store.getters.lang.data.yes_btn}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>
<script>
    import controller from './../../controller/item_badges'
    export default {
        data() {
            return {
                item_badges: {},
                search: '',
                loading: true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },
                selected_item_badges: {},
                delete_dialog: false,
                headers: [

                    


                    {
                        text: this.$store.getters.lang.data.item_badge_name,
                        align: 'start',
                        sortable: true,
                        value: 'item_badge_name',
                    },


                    // {
                    //     text: this.$store.getters.lang.data.item_badge_color,
                    //     align: 'start',
                    //     sortable: true,
                    //     value: 'item_badge_color',
                    // },


                    // {
                    //     text: this.$store.getters.lang.data.item_badge_svg,
                    //     align: 'start',
                    //     sortable: true,
                    //     value: 'item_badge_svg',
                    // },


                    {
                        text: this.$store.getters.lang.data.item_name,
                        align: 'start',
                        sortable: true,
                        value: 'item_name',
                    },
                    {
                        text: this.$store.getters.lang.data.item_badge_id,
                        align: 'start',
                        sortable: true,
                        value: 'item_badge_id',
                    },


                ],
            }
        },
        computed: {
            rows() {
                return this.$store.getters.item_badges
            },

            items() {
                return this.$store.getters.items
            },


        },
        mounted() {
            this.read_item_badges();
        },
        methods: {
            add_item_badges() {
                controller.add_item_badges(this.item_badges).then(r => {
                    if (r.data) {
                        this.item_badges = {}
                        this.$store.state.item_badges.push(
                            r.data.new_data
                        )
                        this.snackbar = {
                            value: true,
                            text: 'item_badges Added',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Fail to add item_badges',
                            color: 'error'
                        }
                    }
                })
            },
            delete_item_badges(item_badge_id) {
                controller.delete_item_badges(item_badge_id).then(r => {
                    this.delete_dialog = false
                    if (r.data) {
                        this.$store.state.item_badges = this.$store.state.item_badges.filter(f => {
                            return f.item_badge_id != item_badge_id
                        })
                        this.snackbar = {
                            value: true,
                            text: 'item_badges Deleted',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Delete Faild',
                            color: 'error'
                        }
                    }
                })
            },
            read_item_badges() {
                this.loading = true
                controller.get_item_badges().then(r => {
                    // this.rows = r.data.rows
                    this.loading = false
                })
            },
            select_item_badges(i) {
                this.selected_item_badges = i
                this.delete_dialog = true
            },
        },
    }
</script>